import MultiStreamRecorder from 'recordrtc';
import { injectMetadata } from '@/utils/video';
import logger from '@/modules/Logger';

export default {
  namespaced: true,
  state: {
    isRecording: false,
    recorder: null,
    blob: null,
    displayStream: null,
    recordingTime: 0,
    interval: null,
  },

  mutations: {
    setRecording(state, payload) {
      state.isRecording = payload
    },
    setRecorder(state, payload) {
      state.recorder = payload
    },
    setBlob(state, payload) {
      state.blob = payload
    },
    setDisplayStream(state, payload) {
      state.displayStream = payload
    },
    setRecordingTime(state, payload) {
      state.recordingTime = payload
    },
    setTimeInterval(state, payload) {
      state.interval = payload
    }
  },

  actions: {
    initRecorder({ state, commit }, streams) {
      let multiStreamRecorder = new MultiStreamRecorder(streams, {
        elementClass: 'multi-streams-mixer',
        mimeType: 'video/webm;codecs=vp9',
        frameInterval: 60,
        video: {
          height: window.screen.height * window.devicePixelRatio,
          width: window.screen.width * window.devicePixelRatio
        }
      });

      multiStreamRecorder.ondataavailable = function (blob) {
        commit('setBlob', blob)
      };

      logger.info('Recording Started.', { operation: 'recorder', rec_status: 'used' });
      multiStreamRecorder.startRecording();    

      commit('setRecorder', multiStreamRecorder);  

      let interval = setInterval(function () {
        commit('setRecordingTime', state.recordingTime + 1)
      }, 1000);

      commit('setTimeInterval', interval);
    },

    addStreams({ state }, streams) {
      state.recorder.getInternalRecorder().addStreams(streams)
    },   
    stopRecorder({ state, commit }) {
      if (state.recorder != null) {
        let url = null;
        let link = document.createElement("a");
        state.recorder.stopRecording(async function () {
          let seekableBlob = await injectMetadata(state.recorder.getBlob());
          url = window.URL.createObjectURL(seekableBlob);
          link = document.createElement("a");
          document.body.appendChild(link);
          link.style = "display: none";
          link.href = url;
          link.download = 'video.webm';
          link.click();
          window.URL.revokeObjectURL(url);
          commit('setRecorder', null);
        });  
        commit('setRecording', false);   
        clearInterval(state.interval);
        commit('setRecordingTime', 0)    
        state.displayStream.getTracks().forEach(track => {
          track.stop();
        });

        logger.info('Recording Stopped.', { operation: 'recorder' });
      }
    },   
    resetRecorder({ state }, streams) {
      state.recorder.getInternalRecorder().resetVideoStreams(streams);
      logger.info('resetting recorder is successful.', { operation: 'recorder' });
    }
  }
}
